import styled from 'styled-components'

import colors from 'utils/colors'
import { FixMeLater } from 'types'
import { MOBILE_DEVICE_WIDTH } from 'utils/constants'
import { CustomButtontypographyKey } from './cbTypography'
import { CustomTextTypographyKey } from 'components/text/customTextTypography'

import CustomIcon, { IconSourceType } from 'components/icon/CustomIcon'
import CustomText from 'components/text/CustomText'
import FilePicker from './FilePicker'

type IconAlignment = 'left' | 'right'
type IconPreset = 'xSmall' | 'small' | 'thin' | 'medium' | 'grande' | 'large' | 'xLarge' | 'xxLarge'

type ButtonType = 'primary' | 'secondary' | 'danger'

type ButtonSize = 'small' | 'medium' | 'large'

interface ICustomButtonProps {
  text: string
  typography?: CustomTextTypographyKey
  textColor?: string
  icon?: IconSourceType
  iconAlignment?: IconAlignment
  iconPreset?: IconPreset
  type?: ButtonType
  size?: ButtonSize
  disabled?: boolean
  className?: string
  isFilePicker?: boolean
  getInputProps?: FixMeLater
  buttonType?: 'submit' | 'button' | 'reset'
  onClick?: () => void
  inputRef?: FixMeLater
}

const CustomButton = ({
  text,
  typography = 'header2',
  textColor = colors.white,
  icon,
  iconAlignment = 'left',
  iconPreset = 'medium',
  type = 'primary',
  size = 'medium',
  disabled = false,
  className,
  isFilePicker,
  getInputProps,
  buttonType = 'submit',
  inputRef,
  onClick,
}: ICustomButtonProps) => {
  let typeTypography
  let sizeProp

  if (type === 'secondary') textColor = 'black'
  if (type === 'primary') typeTypography = CustomButtontypographyKey.primary
  if (type === 'secondary') typeTypography = CustomButtontypographyKey.secondary
  if (type === 'danger') typeTypography = CustomButtontypographyKey.danger

  if (size === 'small') sizeProp = CustomButtontypographyKey.small
  if (size === 'medium') sizeProp = CustomButtontypographyKey.medium
  if (size === 'large') sizeProp = CustomButtontypographyKey.large
  return (
    <ButtonWrapper
      className={className}
      size={sizeProp}
      disabled={disabled}
      onClick={onClick}
      type={buttonType}
      buttonStyle={typeTypography}
      hasIcon={icon != undefined}
    >
      {iconAlignment == 'left' && icon && <CustomIcon source={icon} iconPreset={iconPreset} />}
      {typography && (
        <ResponsiveCustomText
          isEmpty={text.length === 0}
          color={textColor}
          className="button-text"
          typography={typography}
          cursor="pointer"
          whiteSpace="nowrap"
        >
          {text}
        </ResponsiveCustomText>
      )}
      {iconAlignment == 'right' && icon && <CustomIcon source={icon} iconPreset="medium" />}
      {isFilePicker && <FilePicker getInputProps={getInputProps} inputRef={inputRef} />}
    </ButtonWrapper>
  )
}

export default CustomButton

const ResponsiveCustomText = styled(CustomText).attrs((props: { isEmpty?: boolean }) => props)`
  @media only screen and (max-width: ${MOBILE_DEVICE_WIDTH}px) {
    display: ${({ isEmpty }) => (isEmpty ? 'none' : 'block')};
  }
`
const ButtonWrapper = styled.button.attrs((props: FixMeLater) => props)`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  gap: 13px;
  box-shadow: 0px 2px 5px ${colors.gray60};
  border-radius: 4px;
  width: ${(props) => props.size.width};
  padding: ${(props) => (props.hasIcon ? props.size.withIconPadding : props.size.padding)};
  height: ${(props) => props.size.height};
  background-color: ${(props) => props.buttonStyle.backgroundColor};
  color: ${(props) => props.buttonStyle.backgroundColor};
  &:hover {
    background-color: ${(props) => props.buttonStyle.hoverBackgroundColor};
  }
  &:focus-visible {
    // Yalnızca tab index için focus olursa.
    outline: 1px solid ${colors.vime};
    outline-offset: 2px;
  }
  &:disabled {
    color: ${(props) => props.buttonStyle.disabledColor};
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
`
